import { JSONSchema7Object, ConfigurableFormConfig } from "../../../types";
import { get } from "../../../utils/helpers";
import * as formElements from "./formElements";
import validateSchema from "./customerConsent.json";
import formElementsSchema from "./formElements.json";

export const formConfig: ConfigurableFormConfig = {
  fields: [
    {
      ...formElements.sectionHeader,
      label: "customer.consent.sections.termsAndConditions.title"
    },
    { ...formElements.customerConsentIntro },
    {
      ...formElements.fieldCheckbox,
      id: "confirmConsent",
      name: "confirmConsent",
      label: "customer.consent.fields.confirmConsent.label",
      errorMessage: "customer.consent.fields.confirmConsent.errors.required",
      props: {
        required: true
      }
    },
    {
      ...formElements.fieldSignature,
      id: "signatureData",
      name: "signatureData",
      label: "customer.consent.fields.signature.label",
      stateToProps: {
        disabled: (value: any, propName?: string, input?: any) =>
          !get(input, "formState.confirmConsent")
      },
      props: {
        hideLabel: true,
        required: true,
        inputProps: {
          labels: {
            buttonClear: "customer.consent.fields.signature.buttons.clear.label"
          }
        }
      },
      errorMessage: "customer.consent.fields.signature.errors.required"
    }
  ],
  validateSchema: validateSchema as JSONSchema7Object,
  refSchemas: [formElementsSchema as JSONSchema7Object],
  labels: {
    buttonBack: "general.buttons.back.label",
    buttonNext: "general.buttons.continue.label",
    buttonSubmit: "customer.consent.buttons.submit.label"
  }
};

export default formConfig;
